import React from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  INSTALACIONES, normalizarInstalacion, checklistVigente, TEXTO_CHECKLIST_PENDIENTE,
} from 'lib/auditoriaInstalaciones';

// Instalación activa de la pantalla, guardada en la URL (?instalacion=...)
// para que un enlace copiado abra la misma vista. Por defecto canopy.
export function useInstalacion() {
  const [params, setParams] = useSearchParams();
  const instalacion = normalizarInstalacion(params.get('instalacion'));
  const cambiar = (id) => {
    const p = new URLSearchParams(params);
    if (id === 'canopy') p.delete('instalacion');
    else p.set('instalacion', id);
    setParams(p, { replace: true });
  };
  return [instalacion, cambiar];
}

// Selector común (Canopy | Tarzan Swing | Canyoning) de Inspecciones, Hallazgos y Reportes.
export default function SelectorInstalacion({ value, onChange, mostrarChecklist = true }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div role="radiogroup" aria-label="Instalación" className="inline-flex rounded-xl border border-border bg-card p-1">
        {INSTALACIONES.map((i) => {
          const activa = value === i.id;
          return (
            <button key={i.id} type="button" role="radio" aria-checked={activa} onClick={() => onChange(i.id)}
              className={`h-9 rounded-lg px-3 text-sm font-semibold transition ${
                activa ? 'bg-primary text-primary-foreground' : 'text-foreground hover:bg-muted'
              }`}>
              {i.label}
            </button>
          );
        })}
      </div>
      {mostrarChecklist && !checklistVigente(value) && (
        <span className="rounded-full border border-warning/50 bg-warning/10 px-2.5 py-0.5 text-xs font-semibold text-warning-foreground">
          {TEXTO_CHECKLIST_PENDIENTE}
        </span>
      )}
    </div>
  );
}
